import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { TENANT_SETTINGS_KEYS, TENANT_SETTINGS_LABEL_KEYS } from '@/utils/tenant-setting';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import SettingsElements from '@/components/tenant-settings/tenant-settings';
import { isEmptyValue } from '@/utils/utils';
import { TENANT_DEFAULT } from '@/utils/constants';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { sessionService } from '@/providers/services/auth/session';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';

@Component({
    name: 'setup-dashboard',
    components: SettingsElements,
})

export default class SetupDashboard extends Vue {


    public tenantDetail: any = [];

    public nudgesList: any = [];

    public productList: any = [];

    public notFoundSubscriberList: any = '';

    // ---------------------------------------------------------------------------
    // Properties

    private tenantSettings: any = null;

    private tenantKeys: any = TENANT_SETTINGS_KEYS;

    private tanantLabelToKey: any = TENANT_SETTINGS_LABEL_KEYS;

    private tenantItems: any = {};

    private previewItem: any = {};

    private isLoading: boolean = false;

    private defaultLocalKey: any = TENANT_DEFAULT;

    private categorySubjectData: any = [];
    public setDefaultImage(index: any) {
        this.nudgesList[index].thumbnail.thumbnailUrl = this.nudgesList[index].nudge_id === 'recharge' ? '/img/default-images/recharge.svg' : '/img/default-images/profile.png';
    }

    private get loggedTenantId() {
        return this.$access.getTenantId();
    }

    // ---------------------------------------------------------------
    // Hooks

    private created() {
        const tenantId: string = this.loggedTenantId;
        this.fetchTenantDetails(tenantId);
        this.fetchNudgeDetails(tenantId);
        this.fetchSubscribedProductList(tenantId);
        this.fetchTaxonomyClassifications();
        this.fetchTenantSettings();
    }

    private updated() {
        this.setContainerHeight();
    }
    // --------------------------------------------------------------
    // Actions

    private onPreview(group: any) {
        this.previewItem = group;
        this.$bvModal.show('tenant-preview');
    }

    private hideModal() {
        this.$bvModal.hide('tenant-preview');
    }

    private onEditSetting(settings: any, tKey: string) {
        if (tKey === 'subjectsFrameworks' || tKey === 'sso' || tKey === 'classConfiguration' || tKey === 'lorFacets') {
            if (tKey === 'subjectsFrameworks') {
                this.$router.push({ path: '/setup/subjects-facets' });
            } else if (tKey === 'sso') {
                this.$router.push({ path: '/setup/sso-setup' });
            } else if (tKey === 'classConfiguration') {
                this.$router.push({ path: '/setup/class-configuration' });
            } else if (tKey === 'lorFacets') {
                this.$router.push({ path: '/setup/lor-facets' });
            }
        } else {
            this.$router.push({ path: '/setup/tenant-settings', query: { activeSettings: tKey } });
        }
    }

    // --------------------------------------------------------------
    // Methods

    /**
     * @method setContainerHeight Help to set the height of the dashboard page container
     */
    private setContainerHeight() {
        const dashboardContainer = this.$refs.dashbordContainer as HTMLElement;
        if (dashboardContainer) {
            const firstColumn = dashboardContainer.querySelectorAll('.tenant-setting-panel:nth-child(3n+2)');
            const secondColumn = dashboardContainer.querySelectorAll('.tenant-setting-panel:nth-child(3n+1)');
            const lastColumn = dashboardContainer.querySelectorAll('.tenant-setting-panel:nth-child(3n)');
            const totalHeight1 = Array.from(firstColumn).
                reduce((total: any, item: any) => total + item.clientHeight, 0);
            const totalHeight2 = Array.from(secondColumn).
                reduce((total: any, item: any) => total + item.clientHeight, 0);
            const totalHeight3 = Array.from(lastColumn).reduce((total: any, item: any) => total + item.clientHeight, 0);
            const maxCount = Math.max(totalHeight1, totalHeight2, totalHeight3);
            dashboardContainer.style.height = maxCount + (firstColumn.length * 30) + 'px';
        }
    }

    private fetchTenantSettings() {
        const removeObject = 'subjectsFrameworks';
        this.isLoading = true;
        axios.all([
            tenantSettingsAPI.fetchActiveTenantSettings(),
            tenantSettingsAPI.fetcTenantConfigKeys(),
        ]).then(axios.spread((settingsList: any, configkeys: any) => {
            delete configkeys[removeObject];
            this.tenantSettings = configkeys;
            this.tenantItems = settingsList;
            // this.parseTenantSettings(settingsList);
            this.isLoading = false;
        })).catch((error: any) => {
            this.isLoading = false;
        });

    }

    private fetchTenantSettingsById(tenantId: string) {
        this.tenantItems = [];
        const removeObject = 'subjectsFrameworks';
        this.isLoading = true;
        axios.all([
            tenantSettingsAPI.fetchTenantSettingById(tenantId),
            tenantSettingsAPI.fetcTenantConfigKeys(),
        ]).then(axios.spread((settingsList: any, configkeys: any) => {
            delete configkeys[removeObject];
            this.tenantSettings = configkeys;
            this.tenantItems = settingsList;
            // this.parseTenantSettings(settingsList);
            this.isLoading = false;
        })).catch((error: any) => {
            this.isLoading = false;
        });
    }

    private fetchTenantDetails(tenantId: string) {
        this.tenantDetail = [];
        tenantSettingsAPI.fetchTenantDetail(tenantId).then((res) => {
            if (res && res.grant_type) {
                let grantType = res.grant_type.replace(/[{}]/g, '').split(',');
                grantType = grantType.filter((item: any) => item !== 'anonymous');
                res.grantType = grantType.join(',');
            }
            if (res && res.sso_config) {
                const ssoConfig = res.sso_config.find((config: any) => config.is_roaster_applicable === true);
                res.defaultRosterData = ssoConfig;
            }
            this.tenantDetail = res;
        });
    }

    private fetchNudgeDetails(tenantId: string) {
        tenantSettingsAPI.fetchNudgesDetail(tenantId).then((nudgesRes) => {
            const cdnUrls = sessionService.getCdnUrl();
            const contentCdnUrl = cdnUrls.content_cdn_url;
            nudgesRes.list.map((lists: any) => {
                lists.thumbnail.thumbnailUrl = lists.thumbnail.icon ? contentCdnUrl + lists.thumbnail.icon :
                    `${window.location.origin}` + DEFAULT_IMAGES_PATH.assessment;
            });
            nudgesRes.list = nudgesRes.list.filter((value: any, index: any, self: any) =>
                index === self.findIndex((data: any) => (
                    data.id === value.id && data.nudge_id === value.nudge_id
                )),
            );
            this.nudgesList = nudgesRes.list;
        });
    }

    private fetchSubscribedProductList(tenantId: string) {
        tenantSettingsAPI.fetchSubscribedProductList(tenantId).then((productList) => {
            this.productList = productList.data.list;
        })
            .catch((err: any) => {
                this.notFoundSubscriberList = err.response.data.message;
            });
    }

    private parseTenantSettings(settings: any) {
        const tenantSettings: any = this.tenantSettings || {};
        const settingKeys = Object.keys(settings);
        const tenantItems = Object.keys(tenantSettings);
        const filterTenant: any = {};
        tenantItems.forEach((item: any) => {
            const tenantFields = tenantSettings[item];
            Object.values(tenantFields).forEach((tenantObj: any) => {
                const hasKey = settingKeys.indexOf(tenantObj.keyName) !== -1;
                if (!hasKey) {
                    tenantObj.isDisabled = true;
                }
            });
            const activeTenant = Object.values(tenantFields).filter((data: any) => !data.isDisabled);
            if (activeTenant.length) {
                filterTenant[item] = tenantFields;
            }
        });
        this.tenantSettings = filterTenant;
    }

    private isStringType(tenantItems: any, group: any) {
        const value = this.fieldValue(tenantItems, group);
        return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined' ||
            typeof value === null;
    }

    private fieldValue(tenantItems: any, group: any) {
        let value = tenantItems[group.keyName];
        if (group.parentKey) {
            const parentEl = tenantItems[group.parentKey];
            value = parentEl && !isEmptyValue(parentEl[group.keyName]) ? parentEl[group.keyName] : undefined;
        }
        return value;
    }

    private isLogoUrl(tenantItems: any, group: any) {
        const value = this.fieldValue(tenantItems, group);
        return value && typeof value === 'string' && value.indexOf('https://') >= 0 ? true : false;
    }

    private onEditOne(group: any) {
        const onRead = group.isReadOnly ? group.isReadOnly = !group.isReadOnly : true;
        this.$set(group, 'isReadOnly', onRead);
    }

    private isEllipsisActive(parent: any, e: any) {
        const container: any = this.$refs[parent] as HTMLElement;
        const item: any = container ? container[0].querySelectorAll(`#${e}`) : {};
        const returnItem = item && item[0] ? (item[0].offsetWidth < item[0].scrollWidth) : false;
        return returnItem;
    }

    private showMore() {
        setTimeout(() => {
            this.setContainerHeight();
        }, 150);
    }

    private fetchTaxonomyClassifications() {
        taxonomyAPI.fetchTaxonomyClassifications().then(async (categoryList: any) => {
            if (categoryList && categoryList.length > 0) {
                for await (const iterator of categoryList) {
                    iterator.subjectList = await taxonomyAPI.fetchSubjects(iterator.id);
                }
                this.categorySubjectData = categoryList;
            }
        });
    }
}
